import * as React from "react";
import style from "./style.module.scss";
import SubstractIcon from "@/src/views/components/Icon/icons/SubstractIcon";
import Typography from "@/src/views/components/Typography";
import CircleCrossIcon from "../Icon/icons/CircleCrossIcon";

export default function Alert({
  children = "",
  id = "",
  icon = "imperative",
}: {
  children?: string;
  id?: string;
  icon?: "imperative" | "cross";
}) {
  return (
    <div className={style.container} id={id}>
      <div className={style.icon_wrapper}>
        {icon === "imperative" ? (
          <SubstractIcon size={"18px"} />
        ) : (
          <CircleCrossIcon size={"16px"} color="#E84040" />
        )}
      </div>
      <Typography variant={"body-medium-3"} id="typography-alert-message">
        {children}
      </Typography>
    </div>
  );
}
